export default __webpack_public_path__ + "static/top-a0bf497023e9f9e71da9e4eb393098e0.jpg";